package com.zi.support.shared

object MeetingTiming {
    fun state(startAtMillis: Long, nowMillis: Long): String =
        if (startAtMillis <= nowMillis) "ended" else "upcoming"

    fun relativeLabel(startAtMillis: Long, nowMillis: Long): String {
        val remaining = startAtMillis - nowMillis
        if (remaining <= 0L) return "Ended"
        if (remaining < MINUTE) return "in less than a minute"

        val totalMinutes = remaining / MINUTE
        if (totalMinutes < 60L) return "in ${unit(totalMinutes, "minute")}"

        val totalHours = remaining / HOUR
        if (totalHours < 24L) {
            val minutes = (remaining % HOUR) / MINUTE
            return "in ${unit(totalHours, "hour")}${if (minutes > 0) " ${unit(minutes, "minute")}" else ""}"
        }

        val days = remaining / DAY
        val hours = (remaining % DAY) / HOUR
        return "in ${unit(days, "day")}${if (hours > 0) " ${unit(hours, "hour")}" else ""}"
    }

    /**
     * The list heading a meeting sits under on web, Android and iOS: "Today" (any time today, [todayStartMillis] being
     * local midnight), "Upcoming" (later days) or "Past". Today lists earliest first, Upcoming earliest first, Past newest first.
     */
    fun section(startAtMillis: Long, nowMillis: Long, todayStartMillis: Long): String = when {
        startAtMillis >= todayStartMillis && startAtMillis < todayStartMillis + DAY -> TODAY
        startAtMillis > nowMillis -> UPCOMING
        else -> PAST
    }

    const val TODAY = "Today"
    const val UPCOMING = "Upcoming"
    const val PAST = "Past"
    val sections: List<String> = listOf(TODAY, UPCOMING, PAST)

    fun kindLabel(kind: String): String = if (kind == CalendarSync.SITE_VISIT) "Site visit" else "Meeting"

    private fun unit(value: Long, name: String): String = "$value $name${if (value == 1L) "" else "s"}"

    private const val MINUTE = 60_000L
    private const val HOUR = 60L * MINUTE
    private const val DAY = 24L * HOUR
}
